import Vue from 'vue';
import mapsFun from './maps';
import helper from './helper';

// 注册一个全局自定义指令 `v-map`
Vue.directive('map', {
    bind: (el, binding) => {
        const ele = el;
        const key = binding.value.key;
        const value = binding.value.value;
        ele.innerHTML = mapsFun(key, value);
    }
});

Vue.directive('htmlX', {
    bind: (el, binding) => {
        const ele = el;
        ele.innerHTML = binding.value || '';
    }
});

Vue.directive('tips', {
    bind: (el, binding) => {
        const updateTime = helper.tips(el, binding);
        el.$timeout = setInterval(() => helper.tips(el, binding), updateTime);
    },
    unbind: (el) => {
        clearInterval(el.$timeout);
        delete el.$timeout;
    }
});

Vue.directive('headName', {
    inserted(el, data) {
        const eIT = el.innerText;
        if (!eIT) return;
        let defRetainNum = 2;// 默认保留后2个字符
        if (data.value) { // 自定义字符数
            defRetainNum = data.value;
        }
        if (eIT.length > defRetainNum) {
            if (data.arg === 'left') { // 从左边开始截取
                el.innerText = eIT.slice(0, defRetainNum);
            } else {
                el.innerText = eIT.slice(eIT.length - defRetainNum);
            }
        }
    }
});

Vue.directive('shave', {
    bind: (el) => {
        setTimeout(() => {
            window.$(el).shave(50);
        }, 0);
    }
});
// 鼠标移入展示溢出部分的提示
Vue.directive('title', {
    inserted(el) {
        const {
            clientWidth,
            scrollWidth,
            title
        } = el;
        if (!title && scrollWidth > clientWidth) el.title = el.innerText;
    }
});
